export default {"src":"/pro/_next/static/media/zec.11f96d76.svg","height":2500,"width":2500,"blurWidth":0,"blurHeight":0};